import React, {useMemo} from 'react';
import {useSelector} from 'react-redux';
import CreatableSelect from 'react-select/creatable';
import {reactSelectStyle} from 'helpers';
import {EDITOR_ROLE_ID, MANGER_ROLE_ID} from '../../../config';

const style = {height: 44};
export default React.memo(
  ({item, handleChange, setSelectOpen: setSelectOpenMainFunc, isDisabled}) => {
    // get role from url http://localhost:3333/editor
    const url = window.location.href;
    const isEditor = url.includes('/editor');
    const roles = useSelector((state) => state.roles.roles);
    const isClearable = isEditor && !item.roles.includes(EDITOR_ROLE_ID);
    const rolesOptions = useMemo(
      () =>
        roles
          .filter(
            (role) =>
              !isEditor || [EDITOR_ROLE_ID, MANGER_ROLE_ID].includes(role._id)
          )
          .map((role) => ({
            label: role.title,
            value: role._id,
            isFixed: isDisabled || (isEditor && role._id === EDITOR_ROLE_ID),
          })),
      [roles]
    );

    const name = 'roles';
    const setSelectOpen = setSelectOpenMainFunc(name);
    console.log('...', item);
    return (
      <div
        className="input-container custom-input-box box-input-container"
        style={style}
      >
        <div className="d-flex align-items-center box h-100">
          <div className="d-flex justify-content-center align-items-center h-100 select-team-text-container">
            <div className="title">ROLES</div>
          </div>
          <div className="input-container flex-grow-1">
            <CreatableSelect
              isMulti
              isClearable={isClearable}
              menuPlacement="top"
              isDisabled={isDisabled}
              styles={reactSelectStyle({hide: !!item.roles})}
              value={rolesOptions.filter((t) =>
                item.roles.some((r) => r === t.value)
              )}
              onChange={(newValue) => {
                if (newValue?.length) {
                  const result = newValue.map((v) => v.value);
                  console.log(result);
                  if (isEditor && !result.includes(EDITOR_ROLE_ID)) {
                    console.log('editor role should not be removed');
                  } else {
                    handleChange('roles', result);
                  }
                } else {
                  handleChange('roles', []);
                }
              }}
              placeholder=""
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.value}
              options={rolesOptions}
              onMenuClose={() => {
                setSelectOpen(false);
              }}
              onMenuOpen={() => {
                setSelectOpen(true);
              }}
            />
          </div>
        </div>
      </div>
    );
  }
);
